// A step from /finance to a client's own page (finance redesign slice 3): the client drawer's arrow. It stamps the
// breadcrumb trail, so the header leads back to this tab. Main's month drawer's arrow, which opened that month on the
// client's page, is retired with the month (finance consolidation S9).
import { useNavigate } from "react-router-dom";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import { useTrailNavOptions } from "@/core/navigation/trail";

export function useOpenClient() {
  const navigate = useNavigate();
  const trail = useTrailNavOptions(ENTITY_CONFIG.finance.label);
  return {
    page: (clientId: string) => navigate(`/app/${clientId}/finance`, trail),
  };
}
